const ResearcherResearchProjects = () => {
  return (
    <div>
      <h1>Researcher Research Projects</h1>
    </div>
  );
};

export default ResearcherResearchProjects;